/**
 * The small uppercase label over a group of fields, rows or columns, and the
 * head of a table.
 *
 * One definition for both, so the label above a field group and the column
 * headings beside it cannot drift into different greys or different
 * letter-spacing on a screen the operator sees at once. The table head is one
 * step larger because it sits directly over its rows and has to survive being
 * read at a glance while scrolling.
 */
// eslint-disable-next-line no-restricted-syntax -- this is the definition
const LABEL_BASE = 'font-bold uppercase tracking-[0.09em] text-muted-foreground'

/** Over a group of fields. */
export const LABEL_CLASS = `text-[10.5px] ${LABEL_BASE}`

/** Over a table's rows. */
export const TABLE_HEAD_CLASS = `text-[11px] ${LABEL_BASE}`

export { LABEL_BASE }

/**
 * The heading scale.
 *
 * Sizes step down as things nest — a card inside a page may not shout louder
 * than the page it sits in. Left to each screen, this ran from 13 px to 24 px
 * across twenty-three hand-picked values, and a section header came out larger
 * than the page title above it.
 */

/** The one `h1` of a screen, in `PageLayout`. */
export const PAGE_TITLE_CLASS =
  'text-[15px] font-semibold tracking-[-0.01em] text-foreground'

/** A card, pane or panel heading inside a screen. */
export const SECTION_TITLE_CLASS = 'text-[14px] font-semibold text-foreground'

/**
 * A heading inside a block — a storey, a counted group.
 *
 * Not a table row's name: that is `primary` in `Internal/DataTable/cells`,
 * which inherits the row's own size rather than stepping half a pixel over it.
 */
export const ROW_TITLE_CLASS = 'text-[13.5px] font-semibold text-foreground'

/** The explanatory line under any of the three above. */
export const SUBTITLE_CLASS = 'text-[12.5px] text-muted-foreground'

/**
 * A figure that is the point of its block — a total, a price.
 *
 * The one place a number may outgrow the headings around it, because it is
 * what the block exists to show and it is read rather than scanned.
 */
export const FIGURE_CLASS =
  'text-[22px] font-bold tracking-tight tabular-nums text-foreground'

/**
 * A link inside running text or a datasheet value — the accent, underlined on
 * hover, and nothing else.
 *
 * Not `LinkButton variant="link"`: every button size carries a height and
 * horizontal padding, which indents the link out of the column it sits in.
 */
export const INLINE_LINK_CLASS =
  'inline-flex flex-row items-center gap-1.5 text-sm font-medium text-primary hover:underline'
